import type {ReactElement} from 'react';
import React from 'react';
import {TemplateStyleThumbnailOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-transcript-options/components/template-style-thumbnail-options/template-style-thumbnail-options';
import {noop} from '@Utils/general.util';
import {ContextualMenuImageThumbnailOption} from '@Components/contextual-menu/components/contextual-menu-image-thumbnail-option';
import type {SubtitleStyleEditingOptionsProps} from './subtitle-style-editing-options.types';
import {SubtitlesAnimationStyleDropdown} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-transcript-options/components/subtitles-animation-style-dropdown/subtitles-animation-style-dropdown';

export function SubtitleStyleEditingOptions({
  isMobile = false,
  isLoading = false,
  showScrollIcons = false,
  onCustomizeStylesOptionTriggered = noop,
  hideAnimationOptionsAndPresets = false,
  ...props
}: SubtitleStyleEditingOptionsProps): ReactElement<any> {
  const updateCurrentTemplateStyle = async (selectedSubtitleTemplateId: string): Promise<void> => {
    await props.updateSelectedTemplateId(selectedSubtitleTemplateId);
  };

  const getTemplateStylesList = (): ReactElement<any> => {
    return (
      <TemplateStyleThumbnailOptions
        isLoading={isLoading}
        isMobile={isMobile}
        showScrollIcons={showScrollIcons}
        selectedTemplateId={props.selectedTemplateId}
        updateCurrentTemplateStyle={updateCurrentTemplateStyle}
        hideAnimationOptionsAndPresets={hideAnimationOptionsAndPresets}
      />
    );
  };

  const getAnimationStyleOptions = (): ReactElement<any> => {
    return (
      <SubtitlesAnimationStyleDropdown
        updateAppliedAnimationStyle={props.updateAppliedAnimationStyle}
        selectedAnimationStyle={props.selectedAnimationStyle}
        isLoading={isLoading}
        isMobile={isMobile}
        hideAnimationOptionsAndPresets={hideAnimationOptionsAndPresets}
      />
    );
  };

  const getCustomizeStylesOption = (): ReactElement<any> => {
    return (
      <ContextualMenuImageThumbnailOption
        id="image-background-thumbnail-option"
        label={window.i18next.t('pmwjs_style')}
        imgSrc={props.stylesPreviewImageUrl ?? ''}
        isLoading={!props.stylesPreviewImageUrl}
        onEdit={onCustomizeStylesOptionTriggered}
      />
    );
  };

  const getTemplateOptions = (): ReactElement<any> => {
    return (
      <>
        {getTemplateStylesList()}
        {getAnimationStyleOptions()}
      </>
    );
  };

  return (
    <>
      {getTemplateOptions()}
      {isMobile ? null : getCustomizeStylesOption()}
    </>
  );
}
